import React from 'react';

import { Section, preloader } from 'spectacle-ppa';
import balloonSlide from '../../baseSlides/balloonSlide';
import videoSlide from '../../baseSlides/videoSlide';

import ianSaraSilly from '../../images/characters/ian_sara_silly.png';
import ianSaraTwoFingers from '../../images/characters/ian_sara_two_fingers.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile from './song.md';

const md = new MarkdownScript(markdownFile);

export function preloadSong () {
  preloader([
    ianSaraSilly,
    ianSaraTwoFingers
  ]);
}

function songSection ({ regionData, level }) {
  return (
    <Section id="song">

      {/* Welcome */}
      { (level === 1) &&
        balloonSlide({
          id: 'song-intro',
          characterSide: 'right',
          characterImage: ianSaraSilly,
          html: md.getSubSectionAsHtml(`Level ${level} Intro`, 'Content', false, regionData),
          notes: md.getSubSectionAsHtml(`Level ${level} Intro`, 'Notes', false, regionData)
        })
      }

      { (level === 2) &&
        balloonSlide({
          id: 'song-intro',
          characterSide: 'right',
          characterImage: ianSaraSilly,
          html: md.getSubSectionAsHtml(`Level ${level} Intro`, 'Content', false, regionData),
          notes: md.getSubSectionAsHtml(`Level ${level} Intro`, 'Notes', false, regionData)
        })
      }

      {/* Song */}
      {videoSlide({
        id: 'video',
        notes: md.getSubSectionAsHtml('Song', 'Notes', false, regionData),
        youTubeId: md.getSectionMetadata('Song', 'YouTube', regionData)
      })}

    </Section>
  );
}

export default songSection;



// WEBPACK FOOTER //
// ./programs/h2whoaHybrid/sections/03_song/songSection.jsx